import { render } from "./TestDataModels.vue?vue&type=template&id=492a102e"
import script from "./TestDataModels.vue?vue&type=script&lang=js"
export * from "./TestDataModels.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__